<c-custom-translation-item ng-repeat="item in $ctrl.customTranslations track by item.id" item="item" callback="$ctrl.updateItem(item, remove)"></c-custom-translation-item>
